module.exports = __webpack_public_path__ + "img/MH.78bf6cb4.svg";